import React, { useState, useEffect } from 'react';
import { CheckOutline } from 'antd-mobile-icons';
import {t} from "../../../../i18n";
import {WEB_TEMPORARY_GRAY_ENABLED} from "../../../../utils/grayscaleDriverUtils";
import {isAppVersionGreaterThanOrEqual, kNativeMapModeVersion} from "../../../../utils/versionUtils";

interface UploadNotificationProps {
    status: 'retrying' | 'success' | 'none';
    onClick: () => void;
}

const UploadNotification: React.FC<UploadNotificationProps> = ({ status, onClick }) => {
    const [androidGoogleOptimize, setAndroidGoogleOptimize] = useState<boolean>(false);

    useEffect(() => {
        isAppVersionGreaterThanOrEqual(kNativeMapModeVersion).then(result => {
            setAndroidGoogleOptimize(result);
        }).catch(error => {
            console.error('Failed to check app version:', error);
            setAndroidGoogleOptimize(false);
        });
    }, []);

    if (status === 'none') return null;
    const webTempGrayEnabled =  localStorage.getItem(WEB_TEMPORARY_GRAY_ENABLED) && androidGoogleOptimize;
    const failedRetryMessage = webTempGrayEnabled ? t('pages.delivery.temporary.uploading.hintMessage') : t(`pages.delivery.failed.failedRetry`);
    const successMessage = webTempGrayEnabled ? t('pages.delivery.temporary.uploading.successMessage') : t(`pages.delivery.failed.failedRetrySuccess`);
    const isRetrying = status === 'retrying';
    const bgColor = isRetrying ? 'bg-pink-100' : 'bg-green-100';
    const message = isRetrying ? failedRetryMessage : successMessage;
    const icon = isRetrying ? (
        <div className="animate-spin h-5 w-5 border-2 border-pink-700 rounded-full border-t-transparent" />
    ) : (
        <span className="text-green-700">
            <CheckOutline />
        </span>
    );

    return (
        <div
            className={`flex justify-between items-center px-4 py-2 ${bgColor} mb-2`}
            onClick={onClick}
        >
            <span>{message}</span>
            {icon}
        </div>
    );
};

export default UploadNotification;
